import { Trans } from "react-i18next";

export function PrivacyPolicyContent() {
  return (
    <Trans
      i18nKey={"text"}
      ns={"contentDataPrivacy"}
      components={{ ul: <ul />, li: <li /> }}
    ></Trans>
  );
}
